import { render, staticRenderFns } from "./trade-finish.vue?vue&type=template&id=5478f136&scoped=true"
import script from "./trade-finish.vue?vue&type=script&lang=js"
export * from "./trade-finish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5478f136",
  null
  
)

export default component.exports